import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { IMaestroDocumentoUpdateModel } from 'src/app/models/interfaces/maestro-documento/IMaestroDocumentoUpdateModel';
import { MaestroDocumentoUpdateModel } from 'src/app/models/maestro-documento/MaestroDocumentoUpdateModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { MaestroDocumentosService } from 'src/app/services/maestro-documentos/maestro-documentos.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-maestro-documento-editar',
  templateUrl: './maestro-documento-editar.component.html',
  styleUrls: ['./maestro-documento-editar.component.css']
})
export class MaestroDocumentoEditarComponent implements OnInit {
  id: number = 0;
  model: IMaestroDocumentoUpdateModel = new MaestroDocumentoUpdateModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private maestroDocumentoService: MaestroDocumentosService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_DOCUMENTO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.maestroDocumentoService.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {  
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.maestroDocumentoService.update(this.model).subscribe((data) => {
            this.router.navigate(['/configuracion', 'maestro-documentos']);  
          });
        }
      });
    }
  }

}
